var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import Button from 'syf-component-library/ui/atoms/Button';
const CustomButton = forwardRef((_a, ref) => {
    var { buttonType, disabled = false, alt, type = 'button', children, onClick, className, ariaLabel, title } = _a, props = __rest(_a, ["buttonType", "disabled", "alt", "type", "children", "onClick", "className", "ariaLabel", "title"]);
    return (React.createElement(Button, Object.assign({ className: className, buttonType: buttonType, alt: alt, "aria-label": ariaLabel, onClick: onClick, type: type, "data-object": "button", ref: ref, title: title }, props), children));
});
CustomButton.displayName = 'CustomButton';
export default CustomButton;
